import { hashPath } from '../../track/utils';
import { theme } from '@minted/minted-components';
import axios, { AxiosInstance } from 'axios';
import config from 'config';

const endpoint: string = config.get('trackEndpoint');

const defaultPayload = {
  feature: 'wedding_site_customize',
};

class Track {
  instance: AxiosInstance

  constructor() {
    const acceptHeader = 'application/json';

    this.instance = axios.create({
      headers: {
        Accept: acceptHeader,
      },
      withCredentials: true,
    });
  }

  emit(payload: Record<string, any>) {
    const mergedPayload: Record<string, any> = {
      ...defaultPayload,
      ...payload,
    };

    if (endpoint) {
      const visitorCookie = document.cookie
        .split(';')
        .map((cookie) => cookie.trim())
        .find((cookie) => cookie.startsWith('visitorId='));

      if (visitorCookie) {
        mergedPayload.visitor_id = visitorCookie.replace('visitorId=', '');
      }

      const searchParams = new URLSearchParams(mergedPayload);
      const endpointUri = `${endpoint}?${searchParams.toString()}`;

      this.instance.get(endpointUri)
        .then((response) => response);
    } else {
      console.info(
        'Cannot emit track event, no endpoint configured - payload is: ',
        mergedPayload,
      );
    }
  }
}

const track = new Track();

export default track;

type Breakpoint = {
  breakpointName: string,
  breakpointValue: number,
}

export const trackPageLoad = (featureName, site, guestId = null, userId = null) => {
  const width = document.documentElement.clientWidth;
  const smallViewport: Breakpoint = theme.breakpointsList.find(
    (breakpoint: Breakpoint) => breakpoint.breakpointName === 'small',
  ) as Breakpoint;
  const isMobile = width < smallViewport.breakpointValue;
  const referrer = document.referrer;

  const payload = {
    event: 'page_load',
    feature: featureName,
    is_mobile: isMobile,
    referrer_domain: referrer.split('?')[0],
    referrer_hash: hashPath(referrer),
    site_id: site.id,
    site_type: site.siteType,
    url_hash: hashPath(window.location.href),
  };

  if (userId) {
    payload['minted_user_uid'] = userId;
  }

  if (guestId) {
    payload['guest_id'] = guestId;
  }

  track.emit(payload);
};
